import { render, staticRenderFns } from "./StatsTemplate.vue?vue&type=template&id=5cf96371&"
import script from "./StatsTemplate.vue?vue&type=script&lang=ts&"
export * from "./StatsTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VContainer,VFadeTransition})
